import { render, staticRenderFns } from "./user-edit-dialog.vue?vue&type=template&id=9b1afdea&scoped=true&"
import script from "./user-edit-dialog.vue?vue&type=script&lang=js&"
export * from "./user-edit-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1afdea",
  null
  
)

export default component.exports